import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <FaqSection />
        <CarouselSection />
        <FeaturesSection />
        <TopicsSection />
        <UpdatesSection />
        <CardsSection />
        <CommentsSection />
        <AboutSection />
        <AppSection />
        <RankingSection />
        <IndexSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}